import { render, staticRenderFns } from "./DdiSelect.vue?vue&type=template&id=34607a94&scoped=true&"
import script from "./DdiSelect.vue?vue&type=script&lang=js&"
export * from "./DdiSelect.vue?vue&type=script&lang=js&"
import style0 from "./DdiSelect.vue?vue&type=style&index=0&id=34607a94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34607a94",
  null
  
)

export default component.exports